export const passwordValidation = (password: string) =>
  password.trim() === password &&
  !/\s/.test(password) &&
  /[A-Z]/.test(password) &&
  /[a-z]/.test(password) &&
  /\d/.test(password) &&
  /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password);
